import React, { useRef } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SliderWrapper from '../../Components/SliderWrapper';
import type ReactSlick from 'react-slick';
import type { Settings } from 'react-slick';
import { Box, Typography, Grid, Container } from '@mui/material';
import { Blog, Homeimages } from '../../assets';
import SmoothWaveText from '../../Components/SmoothWaveText';

// Testimonials data
const testimonials = [
  {
    name: 'Mallareddy Putluri',
    image: Blog.bloguser,
    text: "I am so happy to say that ' Working with Mr. Rajiv Williams is constant experience for me of course for everyone. Every day He always teaches new things like skill, perspective and many more. he always says in the morning everyday that *DO IT WITH YOUR PASSION AND HEART OR ELSE DONT DO IT* . His deducation and work inspire everyone to give our best always. Having a mentor like him makes you perfect interms of tasks,learning,improving skills,focus about your work and life too.",
  },
  {
    name: 'Sandeep Kylas',
    image: Blog.bloguser,
    text: "I had the privilege of consulting with Rajiv for a real estate matter in the Hyderabad area, and I couldn't have asked for a better advisor. Rajiv's deep understanding of the local market dynamics and his insightful guidance gave us a very good perspective on potential opportunities in Hyderabad. I wholeheartedly recommend Rajiv to anyone seeking expert real estate consultation in Hyderabad/Telangana.",
  },
  {
    name: 'Mohammed Safiuddin',
    image: Blog.bloguser,
    text: 'I had the pleasure of being mentored by Mr Rajiv Williams in developing my interpersonal skills . His expertise and guidance were instrumental in my professional growth. He provides valuable insights, pushed me to expand my skills, and always made time to offer support and advice.Thank you so much .By far you are the best mentor i have ever came across.',
  },
  {
    name: 'Arun K Gattu',
    image: Blog.bloguser,
    text: "I've known Rajiv for a long time, and when it comes to real estate, he's the guy you want in your corner. Need market insights? He's got them. Looking for the best deals? He knows where to find them. Have a real estate query at midnight? Don’t be surprised if he replies in seconds! What makes Rajiv stand out is not just his deep industry knowledge but also his cool, no-stress approach. He simplifies things, gives honest advice, and always delivers with speed and clarity. If real estate is on your mind, Rajiv is the one to call!",
  },
  {
    name: 'Sumanth Reddy Arani',
    image: Blog.bloguser,
    text: 'Rajiv is exceptional in what he does and consistently goes above and beyond to deliver outstanding results to ensure the success of the projects. His enthusiasm, attention to detail, excellent communication skills, and ability to adapt make him a valuable asset to any organization. Moreover, Rajiv is a quick learner who embraces new technologies and industry trends. He consistently stays up to date with the latest advancements, bringing innovative ideas and fresh perspectives to the table. ',
  },
];

// Slider settings
const settings: Settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  pauseOnHover: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1 },
    },
  ],
};

const TestimonialsSection: React.FC = () => {
  const sliderRef = useRef<ReactSlick>(null);

  return (
    <Box sx={{ pt: 10, pb: { xs: 0, md: 8 } }}>
      <Container maxWidth="lg">
        <Box sx={{}}>
          {/* Title Section */}
          {/* <Grid container alignItems="start" sx={{ mb: 6 }}>
            <Grid item xs={12} md={3}>
              <SmoothWaveText
                variant="subtitle2"
                sx={{
                  textTransform: 'uppercase',
                  color: 'primary.main',
                  fontSize: '14px',
                  textAlign: 'start',
                  mb: { xs: 2, md: 0 },
                  fontWeight: 600,
                }}
              >
                Testimonials
              </SmoothWaveText>
            </Grid>
            <Grid
              item
              xs={12}
              md={7}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                my: { xs: 3, md: 0 },
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  // fontSize: 18,
                  textAlign: { xs: 'start', md: 'center' },
                  mb: { xs: 2, md: 0 },
                }}
              >
                RW Mentoring Program Reviews- What clients and mentees say about
                Rajiv Williams
              </Typography>
            </Grid>
          </Grid> */}
           <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '30px', sm: '36px', md: '44px' },
              fontWeight: 700,
              color: '#1c1f26',
              mb: { xs: 2, sm: 1 },
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Testimonials
          </Typography>

          {/* Slider Section */}
          <SliderWrapper ref={sliderRef} {...settings}>
            {testimonials.map((item, index) => (
              <Box key={index}>
                <Grid container>
                  <Grid item xs={12} sx={{ ml: 2 }}>
                    <Box
                      sx={{
                        borderRadius: '15px',
                        border: '2px solid #0f63a5',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        height: { xs: 'auto', md: '380px', lg: '450px' },
                        pl: 2,
                        pr: 2,
                        pt: 2,
                        pb: 2,
                        backgroundColor: '#fff',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                        transition: 'all 0.3s ease',
                        // '&:hover': {
                        //   boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                        //   transform: 'translateY(-2px)',
                        // },
                      }}
                    >
                      {/* Quote Section */}
                      <Box
                        sx={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <Box
                          component="img"
                          src={Homeimages.quote}
                          alt="quote"
                          sx={{ width: 40, mb: 2 }}
                        />
                        <Typography
                          sx={{
                            fontSize: 16,
                            color: '#000',
                            textAlign: 'start',
                            flex: 1,
                          }}
                        >
                          {item.text}
                        </Typography>
                      </Box>

                      {/* Client Info - Always at bottom */}
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          mt: 'auto',
                          borderTop: '2px solid #0f63a5',
                          pt: 3,
                          mb: 2,
                        }}
                      >
                        <Box
                          component="img"
                          src={Homeimages.user}
                          alt={item.name}
                          sx={{
                            width: 60,
                            height: 60,
                            borderRadius: '50%',
                            objectFit: 'cover',
                            mr: 2,
                          }}
                        />
                        <Box>
                          <Typography
                            variant="h6"
                            sx={{ fontSize: 20, mb: 0.5 }}
                          >
                            {item.name}
                          </Typography>
                          {/* <Typography sx={{ color: "black", fontSize: 14 }}>{item.role}</Typography> */}
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            ))}
          </SliderWrapper>
        </Box>
      </Container>
    </Box>
  );
};

export default TestimonialsSection;
